import { usePageInfo } from 'app/frontend/base/config/queries'
import { useTeam } from 'app/frontend/base/config/context/team'
import { eventParticipantStatuses } from 'app/frontend/types/custom/EventParticipantStatus'
import { useMemo } from 'react'
import { useTeamEventParticipantsContext } from '../context/TeamEventParticipantsContext'
import ViewerExistingParticipantsCard from './ViewerExistingParticipantsCard'
import ViewerNewParticipantSignupCard from './ViewerNewParticipantSignupCard'
import { EventActivityLinkedPlanData } from '../hooks/useEventActivityLinkedPlanData'

type ViewerSignupCardProps = {
  event: wowaudit.Event
  activities: wowaudit.EventActivity[]
  linkedPlanDataByActivityId: Map<number, EventActivityLinkedPlanData>
}

const ViewerSignupCard = ({
  event,
  activities,
  linkedPlanDataByActivityId,
}: ViewerSignupCardProps) => {
  const { team } = useTeam()
  const {
    data: { user },
  } = usePageInfo()
  const { allEntries } = useTeamEventParticipantsContext()
  const activeActivities = useMemo(
    () => activities.filter((activity) => activity.active),
    [activities],
  )
  const selectableStatuses = useMemo(
    () =>
      eventParticipantStatuses.filter(
        (status) =>
          status !== 'removed' &&
          team.settings.raidsAvailableStatuses.value.includes(status),
      ),
    [team.settings.raidsAvailableStatuses.value],
  )
  const viewerEntries = useMemo(() => {
    if (!user?.id) return []
    return allEntries
      .filter(
        (entry) => entry.participant.characterReference.userId === user.id,
      )
      .sort((left, right) =>
        left.participant.characterReference.name.localeCompare(
          right.participant.characterReference.name,
        ),
      )
  }, [allEntries, user?.id])

  if (viewerEntries.length > 0) {
    return (
      <ViewerExistingParticipantsCard
        event={event}
        entries={viewerEntries}
        activeActivities={activeActivities}
        linkedPlanDataByActivityId={linkedPlanDataByActivityId}
        selectableStatuses={selectableStatuses}
      />
    )
  }

  return (
    <ViewerNewParticipantSignupCard
      event={event}
      user={user}
      selectableStatuses={selectableStatuses}
    />
  )
}

export default ViewerSignupCard
